import { GetListParams } from 'react-admin';
import {
  CustomDataProvider,
  registerModuleDataProvider,
} from '../../../providers/CustomDataProvider';
import {
  TransferListFilter,
  listTransfers,
} from '../../../services/xbitRelayTransfersService';
import { DEFAULT_TRANSFERS_PROVIDER } from './constants';

const resourceName = 'xbit-relay/transfers';

const pickFilter = (filter: any): TransferListFilter => {
  if (!filter) return {};
  const out: TransferListFilter = {};
  if (filter.status) out.status = filter.status;
  if (filter.userId) out.userId = filter.userId;
  if (filter.id) out.recordId = filter.id;
  if (filter.toAddress) out.toAddress = filter.toAddress;
  if (filter.txHash) out.txHash = filter.txHash;
  if (filter.timeFrom) out.timeFrom = filter.timeFrom;
  if (filter.timeTo) out.timeTo = filter.timeTo;
  return out;
};

export const xbitRelayTransfersDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter || {};
    const provider = filter.provider || DEFAULT_TRANSFERS_PROVIDER;

    const response = await listTransfers({
      ...pickFilter(filter),
      provider,
      page,
      pageSize: perPage,
    });

    const { items = [], total } = response.data || ({} as any);
    return {
      data: items.map((item) => ({ ...item, id: item.id })),
      total: Number(total) || 0,
    };
  },
};

registerModuleDataProvider(resourceName, xbitRelayTransfersDataProvider);
